const pendingBillingRequests = new Map();
const failedBillingKeys = new Map();
export function postBillingOnce(api, path, data = {}) {
  const signature = JSON.stringify([path, data]);
  if (pendingBillingRequests.has(signature)) return pendingBillingRequests.get(signature);
  for (const [signature, operation] of failedBillingKeys) {
    if (operation.expiresAt < Date.now()) failedBillingKeys.delete(signature);
  }
  const key = data.idempotency_key || failedBillingKeys.get(signature)?.key || crypto.randomUUID();
  const pending = api.post(path, { ...data, idempotency_key: key }, { headers: { 'Idempotency-Key': key } })
    .then(result => { failedBillingKeys.delete(signature); return result; }, error => {
      failedBillingKeys.set(signature, { key, expiresAt: Date.now() + 300000 });
      if (failedBillingKeys.size > 100) failedBillingKeys.delete(failedBillingKeys.keys().next().value);
      throw error;
    })
    .finally(() => pendingBillingRequests.delete(signature));
  pendingBillingRequests.set(signature, pending);
  return pending;
}

